<template>
  <main class="no-japanese flex-all-center">
    <p class="note">日本語ページではご利用いただけません。</p>
  </main>
</template>

<script>
export default {
  name: "NotJapanese",
};
</script>

<style scoped>
.no-japanese {
  margin: 40px;
  .note {
    line-height: 1.5;
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/NotJapanese.vue